/** ******************************************************************************* */
/* Bingo Map - gmap                                */
/** ******************************************************************************* */

Bingo.Map.getInstance = function (mapSelector) {
    if (!mapSelector) {
        return Bingo.Map.default;
    }
    return Bingo.Map.instances[mapSelector];
};

Bingo.Map.Instance = function (mode, mapSelector, originPage) {
    if (!mapSelector) {
        console.error('Instance of Bingo.Map cannot be created as given selector is empty.');
    }
    if (Bingo.Map.instances[this.mapSelector]) {
        console.error(`Instance of Bingo.Map with selector [${mapSelector}] already exists.`);
    }
    this._originPage = false;
    if (typeof originPage !== 'undefined' && originPage !== null) {
        this._originPage = originPage;
    }
    // Map instance configuration
    this.mode = mode;
    this.mapSelector = mapSelector;
    this.enableGeoLocation = false;

    // Map instance internal variables (such as map area etc).
    this.area = null;
    this.userLocation = null;
    this.userLocationUsed = false;
    this.clickEventFiredOverInfoBox = false;
    // Event listeners
    this.onInfoWindowDisplayed = [];

    // Register instance and set default if this is first instance.
    if (!Bingo.Map.default) {
        Bingo.Map.default = this;
    }
    Bingo.Map.instances[this.mapSelector] = this;
};

Bingo.Map.Instance.prototype.init = function (location, disableLocation) {
    let center;
    const zoom = Bingo.Map.DEFAULT_ZOOM;
    if (!disableLocation) {
        if (location) {
            center = location;
        } else {
            center = {lat: Bingo.Map.DEFAULT_LOCATION.lat, lng: Bingo.Map.DEFAULT_LOCATION.long};
        }
    }

    // Google map customization
    if (!google.maps.Polygon.prototype.getBounds) {
        google.maps.Polygon.prototype.getBounds = function () {
            const bounds = new google.maps.LatLngBounds();
            this.getPath().forEach((element) => { bounds.extend(element); });
            return bounds;
        };
    }

    // Separate initialization of streetmap view in order to provide better control of controls
    // See: http://stackoverflow.com/questions/10883481/how-to-change-the-position-of-the-instruments-of-street-view
    const panorama = new google.maps.StreetViewPanorama(document.getElementById(this.getSelector()), {
        addressControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
        },
        enableCloseButton: true,
        visible: false, // prevent initial map load
    });

    this.area = new google.maps.Map(document.getElementById(this.getSelector()), {
        center,
        zoom,
        styles: Bingo.Map.DEFAULT_STYLES,
        fullscreenControl: false,
        mapTypeControl: false,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
        },
        streetViewControl: false,
        streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
        },
        streetView: panorama, // pass on manually created panorama object
    });

    // Trigger init callbacks
    for (const selector in Bingo.Map.initCallbacks) {
        if (Bingo.Map.initCallbacks.hasOwnProperty(selector) && selector === this.mapSelector) {
            for (let i = 0; i < Bingo.Map.initCallbacks[selector].length; i++) {
                Bingo.Map.initCallbacks[selector][i](this);
            }
            Bingo.Map.initCallbacks[selector] = [];
        }
    }

    this.area.addListener('click', () => {
        if (!this.clickEventFiredOverInfoBox) {
            this.closeInfoWindow();
        }
        this.clickEventFiredOverInfoBox = false;
    });
};

Bingo.Map.Instance.prototype.closeInfoWindow = function () {
    if (this.window) {
        this.window.close();
        this.window.itemId = null;
    }
};

Bingo.Map.Instance.prototype.checkMarkerThencloseInfoWindow = function () {
    if (this.window && !this.markers.hasOwnProperty(this.window.itemId)) {
        this.window.close();
        this.window.itemId = null;
    }
};

Bingo.Map.Instance.prototype.addListenerOnInfoWindowDisplayed = function (listener) {
    this.onInfoWindowDisplayed.push(listener);
};

Bingo.Map.Instance.prototype.fireListenerOnInfoWindowDisplayed = function (infoWindow) {
    for (let i = 0; i < this.onInfoWindowDisplayed.length; i++) {
        this.onInfoWindowDisplayed[i](infoWindow);
    }
};

Bingo.Map.Instance.prototype.getSelector = function () {
    return this.mapSelector;
};

Bingo.Map.Instance.prototype.getIdSelector = function () {
    return `#${this.mapSelector}`;
};

Bingo.Map.Instance.prototype.getMode = function () {
    return this.mode;
};

Bingo.Map.Instance.prototype.getArea = function () {
    return this.area;
};

Bingo.Map.Instance.prototype.markerHover = function (marker) {
    if (!marker) {
        return;
    }
    if (marker.hasOwnProperty('_circle')) {
        marker._circle.setOptions({strokeColor: Bingo.Map.Marker.COLOR.brown, fillColor: Bingo.Map.Marker.COLOR.brown});
    }
    if (marker.hasOwnProperty('_polygon')) {
        marker._polygon.setOptions({strokeColor: Bingo.Map.Marker.COLOR.brown, fillColor: Bingo.Map.Marker.COLOR.brown});
    }
    marker._instance.scaleMarkerUp(marker);
};
Bingo.Map.Instance.prototype.markerDehover = function (marker) {
    if (!marker) {
        return;
    }
    if (marker.hasOwnProperty('_circle')) {
        marker._circle.setOptions({strokeColor: Bingo.Map.Marker.COLOR.grey, fillColor: Bingo.Map.Marker.COLOR.grey});
    }
    if (marker.hasOwnProperty('_polygon')) {
        marker._polygon.setOptions({strokeColor: Bingo.Map.Marker.COLOR.grey, fillColor: Bingo.Map.Marker.COLOR.grey});
    }
    marker._instance.scaleMarkerDown(marker);
};

Bingo.Map.Instance.prototype.scaleMarkerUp = function (marker) {
    const icon = marker.getIcon();
    icon.url = (icon.url.toString().search('_highlighted') > 0) ? '/src/images/markers/property_highlighted-hover.png?{{buildVersion}}' : '/src/images/markers/property-hover.png?{{buildVersion}}';
    marker.setIcon(icon);

    marker.setOptions({
        zIndex: 10000,
    });

    if (marker._label) {
        marker._label.setOptions({
            color: '#FFFFFF',
            zIndex: 10000,
        });
    }
};

Bingo.Map.Instance.prototype.scaleMarkerDown = function (marker) {
    const icon = marker.getIcon();
    icon.url = (icon.url.toString().search('_highlighted') > 0) ? '/src/images/markers/property_highlighted.png?{{buildVersion}}' : '/src/images/markers/property.png?{{buildVersion}}';
    marker.setIcon(icon);

    marker.setOptions({
        zIndex: (marker._zIndex ? marker._zIndex : 900),
    });
    if (marker._label) {
        marker._label.setOptions({
            color: '#2D2F30',
            zIndex: (marker._zIndex ? marker._zIndex : 900),
        });
    }
};

Bingo.Map.Instance.prototype.extractCoordinatesFromDbPoint = function (value) {
    const latLngRaw = value.substr(6, value.length - 7);
    const latLng = latLngRaw.split(' ', 2);
    if (latLng.length !== 2 || (latLng[0].length === 0 && latLng[1].length === 0)) {
        return null;
    }
    return {lat: parseFloat(latLng[1]), lng: parseFloat(latLng[0])};
};

Bingo.Map.Instance.prototype.extractCoordinates = function (value) {
    const latlng = value.split(',', 2);
    if (latlng.length !== 2 || (latlng[0].length === 0 && latlng[1].length === 0)) {
        return null;
    }
    return {lat: parseFloat(latlng[0]), lng: parseFloat(latlng[1])};
};

Bingo.Map.packCoordinates = function (lat, long) {
    return `${lat.toFixed(6)},${long.toFixed(6)}`;
};

Bingo.Map.fireResizeEvent = function () {
    if (document.createEvent) { // W3C
        const ev = document.createEvent('Event');
        ev.initEvent('resize', true, true);
        window.dispatchEvent(ev);
    } else { // IE
        const element = document.documentElement;
        const event = document.createEventObject();
        element.fireEvent('onresize', event);
    }
};

Bingo.Map.registerInitCallback = function (selector, callback) {
    if (!Bingo.Map.initCallbacks.hasOwnProperty(selector)) {
        Bingo.Map.initCallbacks[selector] = [];
    }
    Bingo.Map.initCallbacks[selector].push(callback);
};

Bingo.Map.reloadAllInstancesIn = function (divSelector) {
    const output = [];
    const selectors = Object.keys(Bingo.Map.instances);
    for (let i = 0; i < selectors.length; i++) {
        output.push(`#${selectors[i]}`);
    }
    $(divSelector).find(output.join(', ')).each(function () {
        Bingo.Map.getInstance(this.id).reload();
    });
};


Bingo.Map.Instance.prototype.addButton = function (position, className, callback) {
    const controlDiv = document.createElement('div');
    controlDiv.className = (className) ? `${'gm-custom-btn '}${className}` : 'gm-custom-btn';
    this.area.controls[position].push(controlDiv);
    if (callback) {
        controlDiv.addEventListener('click', callback);
    }
};

Bingo.Map.Instance.prototype.useUserLocation = function () {
    if (!this.userLocationUsed && this.userLocation) {
        this.userLocationUsed = true;
        this.getArea().panTo(this.userLocation);
        this.getArea().setZoom(Bingo.Map.DEFAULT_ZOOM);
    }
};

Bingo.Map.Instance.prototype.showLoadingFailed = function () {
    $(`${this.getIdSelector()} #${Bingo.Map.LOADING_SELECTOR}`).addClass('d-none');
    $(`${this.getIdSelector()} #${Bingo.Map.LOADING_FAILED_SELECTOR}`).removeClass('d-none');
};

Bingo.Map.Instance.prototype.centerOnDefault = function () {
    this.getArea().panTo(new google.maps.LatLng(Bingo.Map.DEFAULT_LOCATION.lat, Bingo.Map.DEFAULT_LOCATION.long));
    this.getArea().setZoom(Bingo.Map.DEFAULT_ZOOM);
};

Bingo.Map.Instance.prototype.reload = function () {
    Bingo.Map.fireResizeEvent();
    this.useUserLocation();
    // When the position (center, bounds, zoom) is changed while the map is hidden,
    // the new bounds must be provided when it becomes visible, otherwise the map is unzoomed to some exotic location.
    if (this.getMode() === Bingo.Map.MODE_POSITION_SELECT) {
        if (this.position !== null) {
            this.fitBounds(this.getMarkerBounds());
        }
    } else if (this.getMode() === Bingo.Map.MODE_MARKER_LIST) {
        this.fitBounds();
    } else if (this.getMode() === Bingo.Map.MODE_SEARCH_LIST) {
        this.fitBounds();
    }
};

Bingo.Map.Instance.prototype.isMapVisible = function () {
    // Inspired by: http://stackoverflow.com/questions/178325/checking-if-an-element-is-hidden
    return $(this.getIdSelector()).is(':visible');
};

Bingo.Map.Instance.prototype.reloadOnDisplaying = function () {
    let attempts = 100; // trying maximaly 10 seconds, then we resign on map to initialize properly
    const self = this;
    const temp = function () {
        attempts -= 1;
        if (self.isMapVisible()) {
            self.reload();
        } else if (attempts > 0) {
            setTimeout(temp, 100);
        }
    };
    // Prevent not needed reload when map was already visible
    if (!this.isMapVisible()) {
        temp();
    }
};

Bingo.Map.Instance.prototype.fitBounds = function (bounds, maxZoom) {
    const map = this.getArea();
    if (maxZoom) {
        const originalMaxZoom = map.maxZoom;
        map.setOptions({maxZoom});
        map.fitBounds(bounds); // asynchronous!
        // Restore max zoom at the moment the bounds have already been changed.
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            map.setOptions({maxZoom: originalMaxZoom});
        });
        setTimeout(() => {
            google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000); // remove for the case that bound haven't changed
    } else {
        map.fitBounds(bounds); // asynchronous!
    }
};


Bingo.Map.Instance.prototype.createInfoBox = function (marker) {
    // Make deep copy of default options to prevent overriding by another info box
    const infoBoxOptions = JSON.parse(JSON.stringify(Bingo.Map.InfoBoxOptions));

    if (typeof marker._info === 'string') {
        // ..in case of single preview
        const boxText = document.createElement('div');
        boxText.innerHTML = marker._info;
        // Show big preview on map
        boxText.firstElementChild.classList.remove('-small');
        // Change gallery from vertical to horizontal when highlighted
        const highlightedBoxText = boxText.querySelector('.O-preview__gallery.-vertical');
        if (highlightedBoxText) {
            highlightedBoxText.classList.replace('-vertical', '-horizontal');
        }
        infoBoxOptions.content = boxText;
        if (window.matchMedia('(max-width: 991px)').matches) {
            infoBoxOptions.pixelOffset = new google.maps.Size(-200, this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND_LIST ? -290 : -300);
            infoBoxOptions.boxStyle.width = '320px';
            infoBoxOptions.boxStyle.marginTop = '40px';
        } else {
            infoBoxOptions.pixelOffset = new google.maps.Size(-200, this._originPage === Bingo.Map.ORIGIN_PAGE_MODE.DEMAND_LIST ? -290 : -450);
            infoBoxOptions.boxStyle.width = '400px';
        }
        infoBoxOptions.boxStyle.paddingRight = '50px';
    } else {
        // ..in case of list of multiple small previews
        infoBoxOptions.content = marker._info;
        infoBoxOptions.boxStyle.width = '431px';
        infoBoxOptions.pixelOffset = new google.maps.Size(-218, -380);
    }

    const windowBox = new InfoBox(infoBoxOptions);
    windowBox.open(this.getArea(), marker);

    windowBox.itemId = marker._itemId;
    google.maps.event.addListenerOnce(windowBox, 'domready', () => {
        this.fireListenerOnInfoWindowDisplayed();
        Bingo.Tooltip.init();

        if (marker.hasOwnProperty('_windowClass')) {
            const iwOuter = $('.google-info-bubble');
            const iwParent = iwOuter.parent().parent();
            iwParent.addClass(marker._windowClass);
        }

        $(`#${this.mapSelector} .A-mapInfoBox`)
            .mouseover(() => { //  disable map scrolling on infobox
                this.getArea().setOptions({draggable: false});
            })
            .mouseout(() => { //  egain enable map scrolling on infobox
                this.getArea().setOptions({draggable: true});
            })
            .click(() => { // set variable to be used for closing info box, when clicking on map
                this.clickEventFiredOverInfoBox = true;
            });

        $(`#${this.mapSelector} .A-mapInfoBox__close`).click((e) => {
            this.getArea().setOptions({draggable: true});
            this.window.itemId = null;
            e.preventDefault();
            e.stopPropagation();
        });

        const galleryCarousel = $(`#${this.mapSelector} .O-preview__carouselItems`);
        const galleryCarouselControl = $(`#${this.mapSelector} .O-preview__carouselArrow`);

        // change ID for carousel because of duplicity
        const suffix = '-infoBoxCarousel';
        galleryCarousel.attr('id', galleryCarousel.attr('id') + suffix);

        // prevent event propagation if it is carousel
        galleryCarouselControl.dblclick((e) => {
            e.preventDefault();
            e.stopPropagation();
        });
        galleryCarouselControl.click(function () {
            $(this).parent().find('.prevent-image-load').each(function () {
                const src = $(this).attr('data-src');
                const alt = $(this).attr('data-alt');
                $(this).after(`<img src="${src}" alt="${alt}">`);
                $(this).remove();
            });
        });
        Bingo.reinitNetteAjax();
        Bingo.PreviewGallery.initMultiple('.js-preview__carouselItems');
    });

    return windowBox;
};

Bingo.Map.Instance.prototype.createMarkerClusterer = function (area, list) {
    const clusterer = new MarkerClusterer(area, list, {
        enableRetinaIcons: true,
        minClusterSize: 2,
        averageCenter: true,
        gridSize: 50,
        clusterClass: 'A-mapCluster',
        styles: [{
            url: '/src/images/markers/group.svg?{{buildVersion}}',
        }],
        enableClusterClick: true,
    });

    clusterer.onClick = function (clickedClusterIcon) {
        if (Bingo.OfferFilterForm.mobileFilterOpened) {
            Bingo.OfferFilterForm.hideMobileFilters();
        }
        if (clickedClusterIcon.cluster_.getMarkers().length > 1) {
            const markerPositions = [];

            // get marker position in cluster
            clickedClusterIcon.cluster_.getMarkers().forEach((marker) => {
                markerPositions.push(`${marker.position.lat().toFixed(2)}_${marker.position.lng().toFixed(2)}`);
            });

            //  count number of occurences in markerPositions array
            const uniq = markerPositions
                .map(name => ({count: 1, name}))
                .reduce((a, b) => {
                    a[b.name] = (a[b.name] || 0) + b.count;
                    return a;
                }, {});

            //  get the duplicates and decide, if we should zoom or show list of offers
            const duplicates = Object.keys(uniq).filter(a => uniq[a] > 1);

            if (duplicates.length !== Object.keys(uniq).length || Object.keys(uniq).length > 1) {
                mz = this.getArea().maxZoom;
                theBounds = clickedClusterIcon.cluster_.getBounds();
                clickedClusterIcon.getMap().fitBounds(theBounds);
            } else {
                const content = document.createElement('div');
                content.className = 'google-info-bubble-scrollable';
                content.id = 'google-info-bubble';

                for (let i = 0; i < clickedClusterIcon.cluster_.getMarkers().length; i++) {
                    content.innerHTML
                        += `<div class="marker_offer_info T-search__resultItem mb-2" data-id="${clickedClusterIcon.cluster_.getMarkers()[i]._itemId}" id="marker_offer_info2_${clickedClusterIcon.cluster_.getMarkers()[i]._itemId}">${
                            clickedClusterIcon.cluster_.getMarkers()[i]._info2
                        }</div>`;
                }
                this.closeInfoWindow();
                // Convert cluster center to marker for InfoBx to work
                const info = new google.maps.Marker();
                info.set('position', clickedClusterIcon.cluster_.center_);
                info._info = content;

                let infowindow = null;
                if (clickedClusterIcon._window) {
                    infowindow = clickedClusterIcon._window;
                    infowindow.open(this.getArea(), info);
                } else {
                    infowindow = this.createInfoBox(info);
                }
                if (typeof i !== 'undefined' && typeof clickedClusterIcon.cluster_.getMarkers()[i] !== 'undefined') {
                    infowindow.itemId = clickedClusterIcon.cluster_.getMarkers()[i]._itemId;
                }
                infowindow.cluster = true;

                this.window = infowindow;
                clickedClusterIcon._window = infowindow;
                google.maps.event.addListener(infowindow, 'domready', () => {
                    this.fireListenerOnInfoWindowDisplayed();
                    const iwOuter = $('.google-info-bubble');
                    const iwParent = iwOuter.parent().parent();
                    iwParent.addClass('is-grouped');
                    if (typeof this.askForInfo === 'function') {
                        this.askForInfo();
                    }
                    Bingo.ImageController.init('google-info-bubble');
                });
            }
            return false;
        }
        return true;
    }.bind(this);
    return clusterer;
};
